import React from 'react';

interface IProjectContext {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  selectValue: number;
  setSelectValue: React.Dispatch<React.SetStateAction<number>>;
}

const ProjectContext = React.createContext<IProjectContext>(
  // Dirty Type hack
  null as unknown as IProjectContext
);

export default ProjectContext;
export const useProjectContext = () => {
  return React.useContext(ProjectContext);
};
